export default function doesContainerMatchToShippingMethod(container, shippingMethod) {
    if (!container || !shippingMethod) {
        return false
    }

    if (!container.shippingMethod) {
        return false
    }

    return container.shippingMethod.id === shippingMethod.id
}